import React, { useState } from "react";

const TABS = [
  { key: "programming", label: "قسم البرمجة" },
  { key: "design", label: "قسم تصاميم" },
  { key: "other", label: "أخرى" },
];

const MONTHS = [
  { value: "01", label: "يناير" },  { value: "02", label: "فبراير" },
  { value: "03", label: "مارس" },   { value: "04", label: "أبريل" },
  { value: "05", label: "مايو" },   { value: "06", label: "يونيو" },
  { value: "07", label: "يوليو" },  { value: "08", label: "أغسطس" },
  { value: "09", label: "سبتمبر" }, { value: "10", label: "أكتوبر" },
  { value: "11", label: "نوفمبر" }, { value: "12", label: "ديسمبر" },
];

const MONTH_NAMES = Object.fromEntries(MONTHS.map((m) => [m.value, m.label]));

const ReportsTab = ({ reports, activeReportTab, setActiveReportTab }) => {
  const activeReports = reports[activeReportTab] || [];

  // ── فلتر الشهر (للتقارير الشهرية فقط) ──────────────────────────────
  const [filterMonth, setFilterMonth] = useState("");

  // ── تاب التقرير الشهري ──────────────────────────────────────────────
  if (activeReportTab === "comreport") {
    const monthlyReports = reports.comreport || [];

    // الشهور الموجودة فعلاً في البيانات (للفلتر)
    const availableMonths = [...new Set(monthlyReports.map((r) => String(r.month).padStart(2, "0")))]
      .sort()
      .map((v) => ({ value: v, label: MONTH_NAMES[v] || v }));

    // التقارير بعد الفلتر
    const filtered = filterMonth
      ? monthlyReports.filter((r) => String(r.month).padStart(2, "0") === filterMonth)
      : monthlyReports;

    return (
      <div className="monthly-tab-wrapper">

        {/* ── فلتر الشهر ── */}
        {availableMonths.length > 1 && (
          <div className="monthly-filter-bar">
            <span className="monthly-filter-label">
              <i className="fa-solid fa-filter"></i> فلتر الشهر:
            </span>
            <div className="monthly-filter-btns">
              <button
                className={`monthly-filter-btn ${!filterMonth ? "active" : ""}`}
                onClick={() => setFilterMonth("")}
              >
                الكل
              </button>
              {availableMonths.map((m) => (
                <button
                  key={m.value}
                  className={`monthly-filter-btn ${filterMonth === m.value ? "active" : ""}`}
                  onClick={() => setFilterMonth(m.value)}
                >
                  {m.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* ── البطاقات ── */}
        {filtered.length === 0 ? (
          <p className="updates-empty">
            {monthlyReports.length === 0
              ? "لا توجد تقارير شهرية حالياً"
              : "لا توجد تقارير لهذا الشهر"}
          </p>
        ) : (
          <div className="monthly-reports-grid">
            {filtered.map((report) => (
              <div key={report.id} className="monthly-report-card">
                <div className="monthly-report-icon">
                  <i className="fa-solid fa-file-pdf"></i>
                </div>
                <div className="monthly-report-info">
                  <h4 className="monthly-report-title">
                    {MONTH_NAMES[String(report.month).padStart(2, "0")] || report.month}{" "}
                    {report.year}
                  </h4>
                  <span className="monthly-report-label">التقرير الشهري</span>
                </div>
                {report.pdf_url ? (
                  <a
                    href={report.pdf_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="monthly-report-btn"
                  >
                    <i className="fa-solid fa-eye"></i>
                    عرض التقرير
                  </a>
                ) : (
                  <span className="monthly-report-no-file">لا يوجد ملف</span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ── تابات البرمجة / التصميم / أخرى ──────────────────────────────────
  return (
    <div className="reports-tab">
      <div className="report-sub-content">
        {activeReports.length === 0 && <p>لا توجد تقارير حالياً</p>}

        {activeReports.map((report) =>
          report.sections.map((section) => (
            <div key={section.id} className="report-section-card">
              {section.image && (
                <img
                  src={section.image}
                  alt={section.title}
                  className="report-section-img"
                />
              )}
              <h4>{section.title}</h4>
              {section.description && <p>{section.description}</p>}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ReportsTab;